import { Injectable } from "@angular/core";
import { UserInfoDTO } from "../classes/UserInfoDTO";
import { CtWebapiGenericResponse, CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { FbGeneralModalConfiguration } from "src/app/components/fb-general-modal/fb-general-modal.configuration";
import { FbGeneralModalComponent } from "src/app/components/fb-general-modal/fb-general-modal.component";
import { ProfileDTO } from "../classes/ProfileDTO";
import { from } from "rxjs";


@Injectable()


export class UserController{

    controller = '/User'
    dialogConfiguration = FbGeneralModalConfiguration.create("Registrazione Avvenuta")
    .setStringList([
        'Grazie per esserti registrato/a su FoodBids!',
        'Siamo entusiasti di averti con noi.',
        'Da oggi potrai partecipare alle aste di prodotti alimentari, scoprire offerte uniche e trovare le occasioni più vantaggiose.'])
    .setLabelButton1('OK')
    .setClosable(false)
    .setAction(() => this.router.navigate(['/login']));
    ref: DynamicDialogRef | undefined;

    //TODO: spostarla da qua, qua manteniamo solo le logiche API

    constructor(
        private ctWebApiService : CtWebapiService,
        private dialogService: DialogService,
        private router: Router
    ){}

    registration(param : UserInfoDTO): void{

        this.ctWebApiService
        .post(new DataRequest(`${this.controller}/Registration`, { hideSpinner: false}), param)
        .subscribe((res: CtWebapiGenericResponse<any>) => {

            if (res.Response.Code !== 200) {


                //TODO: migliorare risposta in caso di errore
                alert(`Registrazione non completat\nErrore: ${res.Response.Message}`);
            }

            else
            {
                //TODO: modalina

                        this.ref = this.dialogService.open(FbGeneralModalComponent, {
                            header: this.dialogConfiguration.title,
                            closable: this.dialogConfiguration.closable,
                            width: '50rem',
                            contentStyle: { "max-height": "500px", "overflow": "auto" },
                            breakpoints: { '1199px': '75vw', '575px': '90vw' },
                            modal: true,
                            data: {
                                configuration: this.dialogConfiguration
                            }
                        });

            }


        });
    }

    getUserInfo(): Promise<ProfileDTO> {

        return new Promise<ProfileDTO>((resolve) => {

            this.ctWebApiService
            .get(new DataRequest(`${this.controller}/Get`, { hideSpinner: false}))
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result);

            })

        });
      }

      setProfileImage(file: File): Promise<boolean> {

        const request: DataRequest = new DataRequest(`${this.controller}/SetProfileImage`);

        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return new Promise<boolean>((resolve) => {

          this.ctWebApiService
            .post(request, formData)
            .subscribe((result: any) =>{
                resolve(true)
            });

        });

      }

      myBatches(param : any | null){

        return new Promise<any>((resolve) => {

            this.ctWebApiService
            .post(new DataRequest(`${this.controller}/MyBatches`, { hideSpinner: false}), param)
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result.Elements);
                else resolve([]);

            })

        });

      }

      MyOffersByStatus(param : any | null){

        return new Promise<any>((resolve) => {

            this.ctWebApiService
            .post(new DataRequest(`${this.controller}/MyOffersByStatus`, { hideSpinner: false}), param)
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result.Elements);
                else resolve([]);

            })

        });

      }


      setCategories(param : any) {

        return new Promise<any>((resolve) => {

            this.ctWebApiService
            .put(new DataRequest(`${this.controller}/SetCategories`, { hideSpinner: false}), param)
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result);
                else resolve(null);

            })

        });
    }


}
